module.exports = __webpack_public_path__ + "static/img/demo_logo.08859c55.svg";